import { importProvidersFrom, ModuleWithProviders, NgModule } from '@angular/core';
import { PaceEnvironment } from '@evorait/pace-core';
import { PaceAuth0AuthService } from '@evorait/pace-authentication';
import { AuthModule } from '@auth0/auth0-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { PaceAuth0XIdTokenInterceptor } from './auth0-x-id-token.interceptor';

@NgModule({
    imports: [],
    providers: [PaceAuth0AuthService],
    exports: [],
    bootstrap: [],
})
export class PaceAuth0AuthenticationModule {
    public static forRoot(environment: PaceEnvironment): ModuleWithProviders<PaceAuth0AuthenticationModule> {
        const allowedUris = [
            {
                uri: `${environment.serviceProtocol}://${environment.serviceHost}/${environment.servicePath}/*`,
                tokenOptions: {
                    authorizationParams: {
                        audience: environment.auth0?.authorizationParams?.audience,
                    },
                },
            },
            {
                uri: `https://*.azurewebsites.net/*`,
                tokenOptions: {
                    authorizationParams: {
                        audience: environment.auth0?.authorizationParams?.audience,
                    },
                },
            },
        ];

        const authConfig = environment.auth0;
        if (!authConfig?.clientId) {
            throw new Error('PaceAuth0AuthenticationModule cannot be configured without a proper Auth0 Config.');
        }

        return {
            ngModule: PaceAuth0AuthenticationModule,
            providers: [
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: PaceAuth0XIdTokenInterceptor,
                    multi: true,
                },
                importProvidersFrom(
                    AuthModule.forRoot({
                        ...authConfig,
                        httpInterceptor: {
                            allowedList: allowedUris,
                        },
                    }),
                ),
            ],
        };
    }
}
